import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomersService {

  baseUrl = `${environment.apis.base}/customers`;

  constructor(private readonly http: HttpClient) { }

  datatable(page?: number, options?: any): Observable<any> {
    let httpParams = new HttpParams();

    if (typeof page === 'number') {
      httpParams = httpParams.append('page', page);
    }

    if ('key' in options && options.key.trim() !== '') {
      httpParams = httpParams.append('search', options.key);
    }

    return this.http.get<any>(this.baseUrl, { params: httpParams });
  }
	getAll(): Promise<any> {
		const url = `${this.baseUrl}`;

		return this.http.get<any>(url).toPromise();
	}
	getActives(): Promise<any> {
		const url = `${this.baseUrl}/active`;

		return this.http.get<any>(url).toPromise();
	}
	getLimits(): Promise<any> {
		const url = `${this.baseUrl}/limits`;

		return this.http.get<any>(url).toPromise();
	}

  /**
   * Obtiene un cliente por su ID.
   */
  show(id: number): Promise<any> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get<any>(url).toPromise();
  }

  /**
   * Crea o actualiza un cliente.
   */
  createOrUpdate(data: RxFormGroup, id?: number): Observable<Object> {
    let url = this.baseUrl;

    if (id) {
      url += `/${id}`;
      return this.http.put<any>(url, data.value);
    } else {
      return this.http.post<any>(url, data.value);
    }
  }

  /**
   * Elimina un cliente por ID.
   */
  delete(id: number): Observable<any> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.delete<any>(url);
  }
}
